import { EnvironmentService } from '@abp/ng.core';
import { inject, Injectable } from '@angular/core';
import { EX_API_URL } from '../domain/ex-api-token';
import { CORE_URL } from '../domain/core-api-token';
import { AI_URL } from '../domain/ai-url-token';
import { CLOUD_FUNCTIONS_URL } from '../domain/cloud-functions-url-token';

@Injectable()
export class GlobalsService {

  private exApiUrl = inject(EX_API_URL);
  private coreApiUrl = inject(CORE_URL);
  private aiApiUrl = inject(AI_URL);
  private cloudFunctionsUrl = inject(CLOUD_FUNCTIONS_URL);

  mainButton: string = 'exp';
  progress: string = 'bg-orange';
  white: string = 'white-bg';
  basic: string = 'bg-zen';
  completed: string = 'bg-zen-green';
  deleted: string = 'bg-zen-red';
  darkRed: string = 'bg-red-800';
  dark: string = 'bg-zen-dark';

  readonly hugeCount: number = 15000;
  readonly lgCount: number = 300;
  readonly xlCount: number = 10000;
  readonly xxlCount: number = 20000;
  readonly xxl2Count: number = 30000;
  readonly xxl3Count: number = 50000;

  readonly md2Count: number = 100;
  readonly mdCount: number = 75;
  readonly avgCount: number = 60;
  readonly smCount: number = 20;

  readonly basicColors = { button: this.mainButton, default: 'bg-white' };

  readonly tableColors = {
    button: this.mainButton,
    STARTED: this.progress,
    COMPLETED: this.completed,
    DELETED: this.deleted,
    PENDING: this.basic,
    DRAFT: this.basic,
    LIVE: this.progress,
    CLOSED: this.completed,
    EXPIRED: this.darkRed,
    INACTIVE: this.dark
  };

  tenantSetup: boolean = false;

  innerRoute: boolean = false;

  constructor(private enviromentService: EnvironmentService) { }

  get sEndpoint(): string {
    return this.exApiUrl;
  }

  get coreAPI(): string {
    return this.coreApiUrl
  }

  get fbFunctionURL(): string {
    return this.cloudFunctionsUrl + "/";
  }
}
